import { styled } from "@mui/material/styles";
import { Avatar, AvatarProps } from "@mui/material";

type AvatarSize = "sm" | "md" | "lg";

const avatarSizes = {
  sm: "24px",
  md: "32px",
  lg: "120px",
};

const StyledAvatar = styled(Avatar)<
  {
    size?: AvatarSize;
    bgColor?: string;
    withBlur?: boolean;
  } & AvatarProps
>`
  font-size: ${({ theme, size }) =>
    size === "lg"
      ? theme.typography.h2?.fontSize
      : theme.typography.bodyS?.fontSize};
  line-height: ${({ theme, size }) =>
    size === "lg"
      ? theme.typography.h2?.lineHeight
      : theme.typography.bodyS?.lineHeight};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.common.white};
  width: ${({ size }) => avatarSizes[size ?? "md"]};
  height: ${({ size }) => avatarSizes[size ?? "md"]};
  background-color: ${({ theme, bgColor }) =>
    bgColor ?? theme.palette.blue.main};
  position: relative;

  &:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: ${({ withBlur }) => (withBlur ? "inline" : "none")};
    background-color: ${({ theme, bgColor }) =>
      bgColor ?? theme.palette.blue.main};
    opacity: 0.3;
  }
`;

export { StyledAvatar };
